import React, { useMemo, useState } from "react";

import { BarChart, Circle, Close } from "@mui/icons-material";
import { Box, Button, Drawer, Link, Tab, Tabs, Typography, useMediaQuery } from "@mui/material";

import photo_1_1 from "./1_1.svg";
import photo_1_2 from "./1_2.svg";
import photo_1_3 from "./1_3.svg";
import photo_1_4 from "./1_4.svg";
//
import photo_2_1 from "./2_1.svg";
import photo_2_3 from "./2_3.svg";
//
const tabs = [
  {
    id: "auto",
    label: "Автоматически, при необходимости",
    links: [
      { name: "Анализ артикула", url: "/dashboard/search/product" },
      { name: "Браузерное расширение — Карточка товара", url: "/dashboard/cabinet?tab=2" },
      { name: "Анализ поставщика (БЕТА)", url: "/dashboard/search/seller" },
    ],
    images: [
      { id: "1_1", src: photo_1_1 },
      { id: "1_2", src: photo_1_2 },
      { id: "1_3", src: photo_1_3 },
      { id: "1_4", src: photo_1_4 },
    ],
  },
  {
    id: "handle",
    label: "Ручным включением",
    links: [
      { name: "Анализ топов поиска", url: "/dashboard/search-tops-analysis" },
      { name: "Мониторинг товаров", url: "/dashboard/monitoring?tab=0" },
      {
        name: "Браузерное расширение — Поисковая выдача, каталоги, таблицы виджетов",
        url: "/dashboard/cabinet?tab=2",
      },
    ],
    images: [
      { id: "2_1", src: photo_2_1 },
      { id: "2_2", src: photo_2_3 },
    ],
  },
];
// ---------------------------------------------------------------------------------------------------------------------
export default function _CerebroDrawer({ isOpen, onClose }) {
  const sxScreen = useMediaQuery("(max-width:480px)");
  const [currentTabId, setCurrentTabId] = useState(tabs[0].id);
  const currentTab = useMemo(
    () => tabs.find(i => i.id === currentTabId) || tabs[0],
    [currentTabId]
  );
  return (
    <Drawer
      open={isOpen}
      {...{ onClose }}
      style={{ zIndex: 10001 }}
      PaperProps={{
        style: {
          width: "100vw",
          maxWidth: "960px",
          display: "grid",
          gridTemplateRows: sxScreen ? "175px 1fr 88px" : "125px 1fr 88px",
        },
      }}>
      <Box p={3} pb={2.5} sx={{ borderBottom: "1px solid #DDE7EE" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <BarChart sx={{ fontSize: 30 }} color={"#171A1C"} />
            <Typography sx={{ color: "#171A1C", fontSize: 20, fontWeight: 500, lineHeight: 1.55 }}>
              Режим «ЦЕРЕБРО»
            </Typography>
          </Box>
          <Close sx={{ fontSize: 24, color: "#636B74", cursor: "pointer" }} onClick={onClose} />
        </Box>
        <Typography sx={{ fontSize: 14, lineHeight: 1.5, color: "#636B74", mt: 1 }}>
          «ЦЕРЕБРО» — это новый алгоритм расчёта выручки. Он применяется там, где данных по остаткам
          уже недостаточно и использует альтернативные подходы для оценки выручки.
        </Typography>
      </Box>
      <Box p={3} pb={5} sx={{ height: "100%", overflowY: "auto" }}>
        <Typography sx={{ fontSize: 18, fontWeight: 600, lineHeight: 1.42, color: "#32383E" }}>
          ЗАЧЕМ НУЖЕН?
        </Typography>
        <Typography sx={{ fontSize: 16, lineHeight: 1.5, color: "#636B74", mt: 2 }}>
          С сентября 2025 года Wildberries ограничил доступ к данным по остаткам для части товаров,
          на основе которых строился расчёт выручки. По тем товарам, где данные остались доступными,
          мы продолжаем считать выручку по остаткам с прежней точностью, по остальным - применяем
          «ЦЕРЕБРО».
        </Typography>
        <Box sx={{ mt: 3, pt: 3 }}>
          <Typography sx={{ fontSize: 20, lineHeight: 1.55, fontWeight: 500, color: "#171A1C" }}>
            Как включается режим «ЦЕРЕБРО»?
          </Typography>
        </Box>
        <Tabs
          value={currentTabId}
          onChange={(_, tabId) => setCurrentTabId(tabId)}
          textColor="inherit" // Отключаем стандартное окрашивание текста
          indicatorColor="secondary" // Используем вторичный цвет для индикатора (кастомизируем ниже)
          sx={{ "& .MuiTabs-indicator": { backgroundColor: "#0B6BCB", height: 2 } }}
          variant="scrollable"
          allowScrollButtonsMobile>
          {tabs.map(item => (
            <Tab
              value={item.id}
              key={item.id}
              label={item.label}
              sx={{
                textTransform: "none",
                fontSize: 16,
                lineHeight: 1.5,
                color: "#32383E",
                //
                "&.Mui-selected": { color: "#0B6BCB", fontWeight: 500 },
                //
                "&:hover": { color: "#1976d2", backgroundColor: "rgba(25, 118, 210, 0.04)" },
              }}
            />
          ))}
        </Tabs>
        <Box sx={{ mt: 3, py: 1.5 }}>
          <Typography
            sx={{
              textTransform: "uppercase",
              fontSize: 16,
              lineHeight: 1.5,
              fontWeight: 500,
              color: "#171A1C",
            }}>
            В каких разделах ?
          </Typography>
          <Box mt={2}>
            {currentTab.links.map(linkItem => (
              <Box
                key={linkItem.name}
                sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                <Circle sx={{ fontSize: 10, color: "#555E68" }} />
                <Link href={linkItem.url} target={"_blank"}>
                  {linkItem.name}
                </Link>
              </Box>
            ))}
          </Box>
        </Box>
        <Box sx={{ mt: 1.5 }}>
          {currentTab.images.map(({ id, src }) => (
            <Box key={id} mb={3} sx={{ img: { width: "100%", height: "auto" } }}>
              <img src={src} alt={id} />
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            height: 45,
            width: "100%",
            borderRadius: "8px",
            border: "1px solid #C7DFF7",
            background: "#4393E4",
            display: "flex",
            alignItems: "center",
            px: 1.5,
          }}>
          <Typography sx={{ color: "white", fontSize: 14, lineHeight: 1.5 }}>
            Для других разделов «ЦЕРЕБРО» в процессе добавления и пока недоступен.
          </Typography>
        </Box>
      </Box>
      <Box p={3} py={2.5} sx={{ borderTop: "1px solid #DDE7EE" }}>
        <Button
          variant="contained"
          sx={{ textTransform: "none", width: "100%", height: 48 }}
          onClick={onClose}>
          Понятно
        </Button>
      </Box>
    </Drawer>
  );
}
